import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import AudioPlayer from '@/components/call_record_detail/AudioPlayer.vue'
  import OperationInformation from '@/components/call_record_detail/OperationInformation.vue'
  import { onMounted, reactive, ref, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import { CallRecord } from '@/types/call_record';
  import { CallRecordRepository } from '@/repositories/CallRecordRepository';

  type View = {
    file_path: string;
    user_name: string;
    started_at: string;
    call_time: number;
  };
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute()

  const view = reactive<View>({
    file_path: '',
    user_name: '',
    started_at: '',
    call_time: 0,
  })

  const show = ref(false);
  const load = async(): Promise<void> => {
    show.value = false;

    const repository = new CallRecordRepository(Number(route.params.project_id));
    const callRecord: CallRecord = await repository.get(Number(route.params.call_record_id))

    view.file_path  = callRecord.file_path;
    view.user_name  = callRecord.user_name;
    view.started_at = callRecord.started_at;
    view.call_time  = callRecord.call_time;

    show.value = true;
  };
  onMounted(load);
  watch(() => route.params.call_record_id, () => {
    if (route.params.call_record_id) {
      load()
    }
  });

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(AudioPlayer, {
          file_path: _unref(view).file_path
        }, null, 8, ["file_path"]),
        _createVNode(OperationInformation, {
          user_name: _unref(view).user_name,
          started_at: _unref(view).started_at,
          call_time: _unref(view).call_time,
          class: "mt50"
        }, null, 8, ["user_name", "started_at", "call_time"])
      ]))
    : _createCommentVNode("", true)
}
}

})